import { useState, useEffect } from 'react'

export function SidebarToggle() {
  const [isSidebarHidden, setIsSidebarHidden] = useState(false)

  const toggleSidebar = () => {
    const sidebar = document.querySelector('.sisbermenu')
    sidebar?.classList.toggle('hidden')
    setIsSidebarHidden(sidebar?.classList.contains('hidden') || false)
  }

  useEffect(() => {
    const sidebar = document.querySelector('.sisbermenu')
    setIsSidebarHidden(sidebar?.classList.contains('hidden') || false)
  }, [])

  return (
    <button
      className={`sidebar-toggle-btn ${isSidebarHidden ? 'sidebar-closed' : ''}`}
      onClick={toggleSidebar}
      aria-label="Toggle sidebar"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5L7 10L12 15"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
